
let TKCache = {
  Config: {},
  Translate: {},
};

export default TKCache;
